<script lang="ts" setup>
import { cn } from '@/utils';
import TextLink from '../ui/text-link/TextLink.vue';

withDefaults(
	defineProps<{
		maxHeight?: string;
	}>(),
	{
		maxHeight: 'max-h-[300px]'
	}
);
const expanded = ref(false);

const contentContainer = useTemplateRef<HTMLElement>('content');

const isOverflowing = computed(() => {
	const container = contentContainer.value;

	if (!container) return false;

	return container?.scrollHeight > container?.clientHeight;
});

const toggleExpand = () => {
	expanded.value = !expanded.value;
};
</script>

<template>
	<div class="flex w-full flex-col gap-4">
		<div class="relative max-h-fit overflow-hidden">
			<div
				ref="content"
				:class="
					cn(
						'whitespace-pre-line transition-all duration-1000 ease-in-out',
						expanded ? '' : maxHeight
					)
				"
			>
				<slot />
			</div>
			<div
				v-show="!expanded && isOverflowing"
				class="absolute bottom-0 z-20 h-24 w-full bg-[linear-gradient(180deg,rgba(255,255,255,0)0%,rgba(255,255,255,0.8)100%)]"
				data-allow-mismatch="style"
			/>
		</div>

		<button
			v-show="isOverflowing"
			class="flex items-start"
			data-allow-mismatch="style"
			@click="toggleExpand"
		>
			<IconMaterialSymbolsLightExpandLess
				v-if="expanded"
				class="size-6 shrink-0 text-primary transition-transform duration-200"
			/>
			<IconMaterialSymbolsLightExpandMore
				v-else
				class="size-6 shrink-0 text-primary transition-transform duration-200"
			/>
			<TextLink as="p" class="font-sans text-base font-normal text-primary">
				{{ expanded ? 'Ver menos' : 'Ver mais' }}
			</TextLink>
		</button>
	</div>
</template>

<style></style>
